import { FunnelVersion } from './FunnelVersion';

export enum FunnelType {
  BLOG = 'BLOG',
  CHAT = 'CHAT',
  EMBED = 'EMBED',
  MP = 'MP',
}

const funnelTypeToPath = new Map([
  [FunnelType.BLOG, /^\/home-solar\/blog/],
  [FunnelType.EMBED, /^\/embed(\/|$)/],
]);

type Funnel = { funnelType: FunnelType; version?: string };

// TODO: Make this a configurable test version, rather than hardcoded to the optimized funnel flag
export const extractFunnelType = (pathname: string, fallbackVersion = FunnelVersion.default): Funnel => {
  const param = pathname?.match(/^\/(v\d+\/|tp\/fe\/)?(\d{4})(\/|$)/)?.[2];
  const version = param && FunnelVersion.includes(param) ? param : fallbackVersion;

  if (!pathname) {
    return { funnelType: FunnelType.MP, version };
  }

  const [match] = [...funnelTypeToPath.entries()]
    .map(([funnelType, path]) => ({ funnelType, params: path.exec(pathname) ?? [] }))
    .filter(({ params }) => params.length > 0);

  const { funnelType = FunnelType.MP } = match ?? {};

  if (funnelType === FunnelType.MP) {
    return { funnelType: FunnelType.MP, version };
  }

  return { funnelType, version };
};
